import { Chip, Grid, Link, Tooltip } from '@material-ui/core';
import ArrowRightIcon from 'mdi-react/ArrowRightIcon';
import React from 'react';
import { WithStyles } from 'decorators/withStyles';
import AlertCircleIcon from 'mdi-react/AlertCircleIcon';

interface IProps {
  classes?: any;
  active?: boolean;
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  released?: boolean;
  callAction: () => void;
}

@WithStyles(theme => ({
  card: {
    margin: '12px 0'
  },
  titleCard: {
    color: theme.variables.colors['primaryColor'],
    fill: theme.variables.colors['primaryColor'],
    '& p': {
      fontSize: '1.1em',
      marginLeft: 10,
      letterSpacing: '0.44px',
      fontWeight: 600,
      margin: 0
    }
  },
  description: {
    '& p': {
      color: '#78909C',
      letterSpacing: '0.44px',
      marginTop: 10,
      marginBottom: 5
    }
  },
  add: {
    '& a': {
      color: '#4CAF50',
      letterSpacing: '0.44px',
      margin: 0,
      cursor: 'pointer'
    }
  },
  link: {
    display: 'flex',
    alignItems: 'center'
  },
  notificationIcon: {
    fill: '#4CAF50',
    marginLeft: 6
  },
  chipActive: {
    backgroundColor: '#D2EBD3',
    color: '#4CAF50',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    border: 'none'
  },
  chipDisabled: {
    backgroundColor: '#ECEFF1',
    color: '#546E7A',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    border: 'none'
  }
}))
export default class CardConfig extends React.PureComponent<IProps> {
  public render() {
    const { classes, callAction, active, title, description, released } = this.props;

    return (
      <Grid container className={classes.card}>
        <Grid item xs={12} justify="space-between" container alignItems="center">
          <Grid className={classes.titleCard} item xs={8} wrap="nowrap" container alignItems="center">
            {React.isValidElement(this.props.icon) && this.props.icon}
            <p>{title}</p>
            {released && (
              <Tooltip title="Nova funcionalidade" placement="top">
                <AlertCircleIcon size={20} className={classes.notificationIcon} />
              </Tooltip>
            )}
          </Grid>
          {active && (
            <Chip
              className={active ? classes.chipActive : classes.chipDisabled}
              label={active ? 'Ativado' : 'Desativado'}
              variant="outlined"
            />
          )}
        </Grid>

        <Grid className={classes.description} item xs={12}>
          <p>{description}</p>
        </Grid>
        <Grid className={classes.add} container item justify="flex-end" xs={12}>
          <Link className={classes.link} onClick={callAction}>
            {active ? 'Alterar' : 'Adicionar'}
            <ArrowRightIcon size="16" />
          </Link>
        </Grid>
      </Grid>
    );
  }
}
